import { Col, Row } from 'antd';
import * as React from 'react';
import { observer } from 'mobx-react';

import { ClientPriorityEditorController } from 'src/app/crm/clients/parts/clientpriority-editor.controller';
import { ClientStatusEditorController } from 'src/app/crm/clients/parts/clientstatus-editor.controller';
import { LanguageEditorController } from 'src/app/general/language/parts/language-editor.controller';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { TextView } from 'src/core/ui/text.view';

interface ClientCommonPartViewProps extends ComponentViewProps<ClientItem> {
	mode: ControlMode;
	tagsQuery: DropdownRequest<AutocompleteSummary>;
}

@observer
export class ClientCommonPartView extends React.Component<ClientCommonPartViewProps, any> {
	constructor(props) {
		super(props);
	}

	render() {
		const model = this.props.model;
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<TextView
							label="Client number"
							mode="display"
							required
							onGetErrorMessage={() => this.props.model.validate(false, 'clientNumber')}
							value={model.clientNumber}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<LanguageEditorController
							setBusy={this.props.setBusy}
							mode={this.props.mode}
							value={model.languageCode}
							onGetErrorMessage={() => this.props.model.validate(false, 'languageCode')}
							onChanged={newVal => model.languageCode = newVal}
							required
						/>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<ClientStatusEditorController
							onGetErrorMessage={() => this.props.model.validate(false, 'status')}
							mode={this.props.mode}
							value={model.status}
							onChanged={newVal => model.status = newVal}
							required
						/>
					</Col>
					<Col xs={24} lg={12}>
						<ClientPriorityEditorController
							onGetErrorMessage={() => this.props.model.validate(false, 'priority')}
							mode={this.props.mode}
							value={model.priority}
							onChanged={newVal => model.priority = newVal}
							required
						/>
					</Col>
					<Col xs={24}>
						<UserEditorController
							label="Login user"
							isRole={false}
							setBusy={this.props.setBusy}
							mode={this.props.mode}
							value={model.loginId}
							onChanged={newVal => model.loginId = newVal ? newVal.id : undefined}
							required
							onGetErrorMessage={() => this.props.model.validate(false, 'loginId')}
						/>
					</Col>
					<Col xs={24}>
						<UserEditorController
							label="Managed by"
							isRole={false}
							onGetErrorMessage={() => this.props.model.validate(false, 'managedById')}
							setBusy={this.props.setBusy}
							mode={this.props.mode}
							value={model.managedById}
							onChanged={newVal => model.managedById = newVal ? newVal.id : undefined}
							required
						/>
					</Col>
					<Col xs={24}>
						<DropdownView
							onGetErrorMessage={() => this.props.model.validate(false, 'dynamicProperties')}
							label="Tags"
							model={model.dynamicProperties.tags}
							disabled={this.props.mode == 'display'}
							onChanged={newVal => {
								model.dynamicProperties.tags = Array.isArray(newVal) ? newVal.map(e => e.value) : [newVal.value]
							}}
							request={this.props.tagsQuery}
							keyField='value'
							textField='value'
							allowNewTags
						/>
					</Col>
					<Col xs={24} lg={12}>
						<BooleanView
							label="Do not email marketing"
							value={model.dynamicProperties.doNotEmailMarketing}
							onChanged={newVal => model.dynamicProperties.doNotEmailMarketing = newVal}
							mode={this.props.mode}
						/>
					</Col>
					<Col xs={24} lg={24}>
						<BooleanView
							label="Do not email customer documentation"
							value={model.dynamicProperties.doNotEmailCustomerDocs}
							onChanged={newVal => model.dynamicProperties.doNotEmailCustomerDocs = newVal}
							mode={this.props.mode}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<BooleanView
							label="Do not email documents"
							value={model.dynamicProperties.doNotEmailDocs}
							onChanged={newVal => model.dynamicProperties.doNotEmailDocs = newVal}
							mode={this.props.mode}
						/>
					</Col>
					<Col xs={24} lg={24}>
						<BooleanView
							label="Do not call (Marketing)"
							value={model.dynamicProperties.doNotCallMarketing}
							onChanged={newVal => model.dynamicProperties.doNotCallMarketing = newVal}
							mode={this.props.mode}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/parts/clientcommon-part.view.tsx